
import React from 'react'

import style from './Search.module.scss'

const Result = ({
  result,
  index,
  engine,
  microcopy
}) => (
  <li key={result.ref} 
    data-index={index} 
    className={style.result}
  >
    <a onClick={() => engine.navigate(result.path) } 
       data-selected={ engine.state.selected === index}
    >
      <strong>{result.title}</strong>
      <span className={style.type} data-type={result.type}>
        { microcopy.text(`search.result_types.${result.type}`) }
      </span>
      <span className={style.description}>
        { result.description }
      </span>
    </a>
  </li>
)

export default Result